<template>
<div :class=" search_status ? 'index page_shop page_b2b page_map page_limit' : 'index page_shop page_b2b page_map'">
    <!-- 关键字搜索 -->
    <div class="index_top top_nobg">
        <div class="PageSearch page-search">
            <van-row type="flex" justify="space-start">
                <van-col v-if="searchlefticon" class="left_col">
                    <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                </van-col>
                <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
                    <van-cell-group class="search_field">
                        <van-field v-model="search_value" :placeholder="placeholder">
                            <van-icon slot="right-icon" :name="righticon" @click="search" />
                        </van-field>
                    </van-cell-group>
                </van-col>
                <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                    <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                </van-col>
            </van-row>
        </div>
        <!-- 分类 -->
        <div class="tab_wrap">
            <van-tabs class="cate_tab" v-model="active" :border="false" title-active-color="#B50001" title-inactive-color="#333333" swipe-threshold="6" @click="cartClick">
                <van-tab v-for="(item, index) in tabcolumn" :key="index" :name="item.name">
                    <div slot="title">{{ item.txt }}</div>
                </van-tab>
            </van-tabs>
        </div>
        <!-- 筛选分类 -->
        <div class="tab_wrap search_tab">
            <van-tabs v-model="search_tab" :border="false" @click="typeClick">
                <van-tab :name="0">
                    <div slot="title">综合</div>
                </van-tab>
                <van-tab :name="1">
                    <div slot="title">最新</div>
                </van-tab>
                <van-tab :name="2">
                    <div slot="title">销量</div>
                </van-tab>
            </van-tabs>
            <!-- 筛选按钮 -->
            <div class="shaixuan" @click="searchPop">筛选</div>
        </div>
        <!--  -->
        <div v-if="!search_status" class="tips">活动专区商品不能与其他商品同时支付</div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <div>
                <!-- 选择项目 -->
                <div class="search_fenlei">
                    <div class="search_title">商品品牌</div>
                    <ul class="search_list clearfix">
                        <li :class="brand.isSelect?'search_item f-l active':'search_item f-l'" v-for="brand in brandList" :key="brand.id" @click="brandClick(brand)">{{brand.name}}</li>
                    </ul>
                </div>
                <!-- 选择分类 -->
                <div class="search_fenlei">
                    <div class="search_title">商品分类</div>
                    <ul class="search_list clearfix">
                        <li :class="cate.isSelect?'search_item f-l active':'search_item f-l'" v-for="cate in goodsCate" :key="cate.id" @click="cateClick(cate)">{{cate.name}}</li>
                    </ul>
                </div>
                <div class="search_fenlei">
                    <div class="search_title">选择分类</div>
                    <ul class="search_list clearfix">
                        <li :class="subCate.isSelect?'search_item f-l active':'search_item f-l'" v-for="subCate in goodsSubCate" :key="subCate.id" @click="subCateClick(subCate)">{{subCate.name}}</li>
                    </ul>
                </div>
                <!-- 价格区间 -->
                <div class="search_fenlei">
                    <div class="search_title">价格区间(元)</div>
                    <div class="price_field">
                        <van-field v-model="minPrice" type="digit" placeholder="最低价格" class="field" />
                        <div class="line"></div>
                        <van-field v-model="maxPrice" type="digit" placeholder="最高价格" class="field" />
                    </div>
                </div>
                <!-- 发货地 -->
                <!-- <div class="search_fenlei">
                    <div class="search_title">发货地</div>
                </div> -->
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 内容 -->
    <div class="index_con">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadGoodsList">
                <div class="datalist btob" style="margin-top:0.4rem">
                    <ul class="list">
                        <li class="item" v-for="(goods,index) in goodsList" :key="index" @click="goShopDetail(goods)">
                            <div class="thumb">
                                <!-- <img :src="goods.good_thumb ? goods.good_thumb: $publicData.intangibleDefault" alt=""> -->
                                <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb: $publicData.intangibleDefault" />
                                <span class="txtli">礼</span>
                            </div>
                            <!-- <div class="item_xinxi">
                                <div class="title_wrap">
                                    <span class="icon_self" v-if="goods.is_self">自营</span>
                                    <span class="icon_new" v-if="goods.is_new">最新</span>
                                    <span class="title"> {{ goods.good_title }}</span>
                                </div>
                                <div class="info clearfix">
                                    <span class="f-l price">¥{{ goods.good_price }}</span>
                                    <span class="f-r source">{{ goods.tradesman_name }}</span>
                                </div>
                            </div> -->
                            <div class="item_xinxi">
                                <div class="title_wrap single">
                                    <div class="title_tag">
                                        <span class="icon_self" v-if="goods.is_self">自营</span>
                                        <span class="icon_new" v-if="goods.is_new">最新</span>
                                    </div>
                                    <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                                    <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                                    <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                                </div>
                                <div class="info clearfix">
                                    <div class="shop_name f-l slh_s">{{ goods.tradesman_name?goods.tradesman_name:'' }}</div>
                                    <div class="source f-r">{{ goods.place }}</div>
                                </div>
                                <div class="info">
                                    <span class="f-l price">¥{{ goods.good_price }}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-list>
        </van-pull-refresh>

    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "home-index",
    data() {
        return {
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_cart.png', // 搜索栏右侧图标
            search_value: '', // 搜索值-关键词
            readonly: false, // 搜索栏只读
            placeholder: '请输入要搜索的商品名称',
            righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
            publicPath: process.env.BASE_URL,
            active: 'a',
            tabcolumn: [], //分类展示数据
            goodsTypeList: [], //分类返回数据
            goodsInfo: {}, //筛选数据
            brandList: [], //品牌数据
            goodsCate: [], //商品分类
            goodsSubCate: [], //二级分类
            goodsList: [], //商品列表
            token: null,
            search_tab: 0,
            search_status: false,
            imageUrl: this.$publicData.uploadImage,
            minPrice: 0,
            maxPrice: 99999,
            cateId: '0', //分类id
            price: [], //价格区间
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
            goNext: false,
            shareConfig: null // 分享的相关配置
        };
    },
    components: {
        PageSearch
    },
    created: function () {

        //测试token
        // this.$store.commit(LOGIN, {
        //     token: 'OwtXMHWz4FWqsNTPYC3fEg==',
        // });
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '商城',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.loadGoodsCates()
                this.onRefresh()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '兑换专区',
                        detail: '限时折扣，超值换好物！\n积分兑换专区又双叒叕上新啦！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'duihuan.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
			this.token = this.$store.getters.token
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
            this.getShareData()
        }
        this.loadGoodsCates()
        
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.onRefresh()
		}
	},
    methods: {
        // 获取数据
        loadGoodsCates() {
            console.log('loadGoodsCates')
            var params = {
                token: this.token
            }
            this.$api.shop.bTobCateInfo(params).then(res => {
                if (res.code == 200) {
                    console.log(res)
                    this.goodsInfo = res.result
                    this.brandList = this.goodsInfo.goodBrand
                    this.goodsTypeList = this.goodsInfo.topCates
                    // if (this.goodsInfo.middleCates.length > 1) {
                    //     this.goodsInfo.middleCates[0].isSelect = true
                    //     this.goodsSubCate = this.goodsInfo.middleCates[0].childList
                    // }
                    this.goodsCate = this.goodsInfo.middleCates
                    var cateList = [{
                        'name': -1,
                        'txt': '全部'
                    }]
                    for (let i = 0; i < this.goodsTypeList.length; i++) {
                        const cate = this.goodsTypeList[i];
                        var newCate = {
                            'name': cate.id,
                            'txt': cate.name
                        }
                        cateList.push(newCate)
                    }
                    this.tabcolumn = cateList
                } else {
                    this.$toast(res.message)
                }
            })
        },
        brandClick(brand) {
            var brandList = this.brandList
            var newList = []
            for (let i = 0; i < brandList.length; i++) {
                var old = brandList[i];
                if (old.id == brand.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.brandList = newList
        },
        cateClick(cate) {
            var cateList = this.goodsCate
            console.log('点选cateList', cateList)
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                if (old.id == cate.id) {
                    old.isSelect = true
                    this.goodsSubCate = old.childList
                } else {
                    old.isSelect = false
                    // var isSelect = false
                    // for (let j = 0; j < old.childList.length; j++) {
                    //     var subCate = old.childList[j];
                    //     if (subCate.isSelect) {
                    // 		isSelect = true
                    // 		old.isSelect = isSelect
                    //         break
                    //     }
                    // }
                    // old.isSelect = isSelect
                }
                cateList[i] = old
            }
            this.goodsCate = cateList
            console.log(this.goodsCate)
        },
        subCateClick(subCate) {
            var goodsSubCate = this.goodsSubCate
            var newList = []
            for (let i = 0; i < goodsSubCate.length; i++) {
                var old = goodsSubCate[i];
                if (old.id == subCate.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.goodsSubCate = newList
            console.log(this.goodsSubCate)
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.loadGoodsList();
        },
        loadGoodsList() {
            var params = {
                token: this.token,
                page: this.page,
                size: this.size,
                
			}
			if(this.cartId != -1){
				params.littleCateIds = [this.cartId]
			}
            
            //筛选中的分类
            var cateList = this.goodsCate
            var cates = []
            if (cateList && cateList.length > 0) {
                for (let i = 0; i < cateList.length; i++) {
                    var old = cateList[i];
                    if (old.isSelect) {
                        for (let j = 0; j < old.childList.length; j++) {
                            var subCate = old.childList[j]
                            if (subCate.isSelect == true) {
                                cates.push(subCate.id)
                            }
                        }
                    }
                }
            }
            // 商品分类
            console.log('cates', cates)
            if (cates.length > 0) {
                params.cate_id = cates
            }
            if (this.search_tab == 1) {
                params.time_order = 1
            } else if (this.search_tab == 2) {
                params.sale_order = 'desc'
            }
            //价格区间
            var price = [this.minPrice, this.maxPrice]
            if (price) {
                params.price = price
            }
            console.log('price', price)
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.keyword = this.search_value
            }
            //品牌
            var brands = []
            if (this.brandList && this.brandList.length > 0) {
                for (let i = 0; i < this.brandList.length; i++) {
                    var old = this.brandList[i];
                    if (old.isSelect) {
                        brands.push(old.id)
                    }
                }
            }

            if (brands.length > 0) {
                params.brandIds = brands
            }
            console.log('params', params)
            this.$api.shop.goodsBToBList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    if (this.page == 1) {
                        this.goodsList = list
                    } else {
                        var old = this.goodsList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.goodsList = old
                    }
                    if (this.goodsList.length >= res.result.total) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }else{
						this.refreshing = false;
						this.loading = false;
						this.page++;
					}
                } else {
                    this.finished = true
                    this.$toast(res.message);
                }
                console.log(this.loading)
            })
        },
        cartClick(name) {
            console.log('tab切换------', name)
            this.cartId = name
            this.onRefresh()
        },
        typeClick(name) {
            this.onRefresh()
        },
        // 点击轮播图
        swiper_img_click(item) {
            console.log(item);
            window.open(item.url)
            // this.$router.push(`/m/count`)
        },
        // 商品详情
        goShopDetail(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?goodsId=" + goods.good_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/shop/detail',
                    query: {
                        goodsId: goods.good_id
                    }
                })
            }
        },
        // 点击搜索图标
        search() {
            this.onRefresh()
        },
        // 搜索pop层
        searchPop() {
            this.search_status = !this.search_status
        },
        // 点击右侧图标  购物车
        clicksearchright() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/cart"
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/shop/cart'
                })
            }

        },
        // 重置
        reset() {
            var brandList = this.brandList
            var newList = []
            for (let i = 0; i < brandList.length; i++) {
                var old = brandList[i];
                old.isSelect = false
                newList.push(old)
            }
            this.brandList = newList
            var cateList = this.goodsCate
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                old.isSelect = false
                for (let j = 0; j < old.childList.length; j++) {
                    var subCate = old.childList[j];
                    subCate.isSelect = false
                    old.childList[j] = subCate
                }
                // if (i == 0) {
                //     this.goodsSubCate = old.childList
                //     old.isSelect = true
                // }
                cateList[i] = old
            }
            this.goodsCate = cateList
            // 价格重置
            this.minPrice = 0
            this.maxPrice = 99999
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '兑换专区', // 分享标题
                    desc: '限时折扣，超值换好物！\n积分兑换专区又双叒叕上新啦！', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'duihuan.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.search {
    max-height: 70vh;
    overflow: auto;
}
</style>
